import React, { Component } from 'react';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import UtilityServices from '../../services/axioServices/apiServices/UtilityServices.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.utilityServices = new UtilityServices();
        this.state = {
            isEditing: false,
            companyDetails: {
                _id: "",
                CompanyGroup: "",
                CompanyName: "",
                mobile: "",
                email: "",
                gstnNo: "",
                msmeNo: "",
                mfgLicNo: "",
                fssaiNo: "",
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                pinCode: "",
                state: "",
                location: "",
                panNo: "",
                bankName: "",
                branch: "",
                acNo: "",
                ifscCode: "",
                termsConditionLine1: "",
                termsConditionLine2: "",
                termsConditionLine3: "",
                termsConditionLine4: ""
            },
            validationRules: {
                CompanyGroup: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "CompanyGroup"
                        ),
                    },
                ],
                CompanyName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "CompanyName"
                        ),
                    },
                ],
                mobile: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "mobile"
                        ),
                    },
                ],
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "email"
                        ),
                    },
                ],
                gstnNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "gstnNo"
                        ),
                    },
                ],
                msmeNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "msmeNo"
                        ),
                    },
                ],
                mfgLicNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "mfgLicNo"
                        ),
                    },
                ],
                fssaiNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "fssaiNo"
                        ),
                    },
                ],
                addressLine1: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "addressLine1"
                        ),
                    },
                ],
                pinCode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "pinCode"
                        ),
                    },
                ],
                state: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "state"
                        ),
                    },
                ],
                location: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "location"
                        ),
                    },
                ],
                panNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "panNo"
                        ),
                    },
                ],
                bankName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "bankName"
                        ),
                    },
                ],
                branch: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "branch"
                        ),
                    },
                ],
                acNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "acNo"
                        ),
                    },
                ],
                ifscCode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "ifscCode"
                        ),
                    },
                ],
                termsConditionLine1: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "termsConditionLine1"
                        ),
                    },
                ],


            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getUserProfile()
    }
    getUserProfile = () => {
        this.utilityServices.getUserProfile().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ isEditing: true })
                let details = this.state.companyDetails
                details._id = response.responseData._id
                details.CompanyGroup = response.responseData.CompanyGroup
                details.CompanyName = response.responseData.CompanyName
                details.mobile = response.responseData.mobile
                details.email = response.responseData.email
                details.gstnNo = response.responseData.gstnNo
                details.msmeNo = response.responseData.msmeNo
                details.mfgLicNo = response.responseData.mfgLicNo
                details.fssaiNo = response.responseData.fssaiNo
                details.addressLine1 = response.responseData.addressLine1
                details.addressLine2 = response.responseData.addressLine2
                details.addressLine3 = response.responseData.addressLine3
                details.pinCode = response.responseData.pinCode
                details.state = response.responseData.state
                details.location = response.responseData.location
                details.panNo = response.responseData.panNo
                details.bankName = response.responseData.bankName
                details.branch = response.responseData.branch
                details.acNo = response.responseData.acNo
                details.ifscCode = response.responseData.ifscCode
                details.termsConditionLine1 = response.responseData.termsConditionLine1
                details.termsConditionLine2 = response.responseData.termsConditionLine2
                details.termsConditionLine3 = response.responseData.termsConditionLine3
                details.termsConditionLine4 = response.responseData.termsConditionLine4
                this.setState({ companyDetails: details })
            }
        });
    };

    addEditUserProfile = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let request = this.state.companyDetails
            this.utilityServices.addEditUserProfile(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    this.SwalServices.Success(response.Message)
                    this.getUserProfile()
                    this.setState({ isEditing: true })
                } else {
                    this.SwalServices.Error(response.Message);
                    this.getUserProfile()
                }
            });
        }
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.companyDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.companyDetails;
        details[name] = value
        this.setState({ companyDetails: details });


    };
    render() {
        return (
            <div className="user-profile">
                <div className="item-form ">
                    <div className="form-table">
                        <div className="item-grp !flex !gap-2.5 !mb-3">
                            <div className="input-grp w-full">
                                <label>Company Group</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.CompanyGroup ? "errorInput" : ""}`}
                                    type="text"
                                    id="CompanyGroup"
                                    name="CompanyGroup"
                                    autocomplete="off"
                                    value={this.state.companyDetails.CompanyGroup}
                                    onChange={(event) =>
                                        this.handleChange(event, "CompanyGroup", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Company Name</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.CompanyName ? "errorInput" : ""}`}
                                    type="text"
                                    id="CompanyName"
                                    name="CompanyName"
                                    autocomplete="off"
                                    value={this.state.companyDetails.CompanyName}
                                    onChange={(event) =>
                                        this.handleChange(event, "CompanyName", "companyDetails")
                                    }
                                />

                            </div>
                            <div className="input-grp w-full">
                                <label>Mobile No.</label>
                                <input
                                    type="number"
                                    id="mobile"
                                    name="mobile"
                                    className={`inputFocus ${this.state.validState?.error?.mobile ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.mobile}
                                    onChange={(event) =>
                                        this.handleChange(event, "mobile", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Email</label>
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    className={`inputFocus ${this.state.validState?.error?.email ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.email}
                                    onChange={(event) =>
                                        this.handleChange(event, "email", "companyDetails")
                                    }
                                />
                            </div>
                        </div>
                        <div className="item-grp !flex !gap-2.5 !mb-3">
                            <div className="input-grp w-full">
                                <label>GST No.</label>
                                <input
                                    type="text"
                                    id="gstnNo"
                                    name="gstnNo"
                                    className={`inputFocus ${this.state.validState?.error?.gstnNo ? "errorInput" : ""}`}
                                    autoComplete='off'
                                    value={this.state.companyDetails.gstnNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "gstnNo", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>MSME No.</label>
                                <input
                                    type="text"
                                    id="msmeNo"
                                    name="msmeNo"
                                    className={`inputFocus ${this.state.validState?.error?.msmeNo ? "errorInput" : ""}`}
                                    autoComplete='off'
                                    value={this.state.companyDetails.msmeNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "msmeNo", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Mfg.Lic.No.</label>
                                <input
                                    type="text"
                                    id="mfgLicNo"
                                    name="mfgLicNo"
                                    className={`inputFocus ${this.state.validState?.error?.mfgLicNo ? "errorInput" : ""}`}
                                    autoComplete='off'
                                    value={this.state.companyDetails.mfgLicNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "mfgLicNo", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Fssai No</label>
                                <input
                                    type="text"
                                    id="fssaiNo"
                                    name="fssaiNo"
                                    className={`inputFocus ${this.state.validState?.error?.fssaiNo ? "errorInput" : ""}`}
                                    autoComplete='off'
                                    value={this.state.companyDetails.fssaiNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "fssaiNo", "companyDetails")
                                    }
                                />
                            </div>
                        </div>

                        <div className="item-grp !flex !gap-2.5 mt-3">
                            <div className="input-grp  w-full">
                                <label>Address Line 1</label>
                                <input
                                    type="text"
                                    id="addressLine1"
                                    name="addressLine1"
                                    autoComplete='off'
                                    className={`inputFocus ${this.state.validState?.error?.addressLine1 ? "errorInput" : ""}`}
                                    value={this.state.companyDetails.addressLine1}
                                    onChange={(event) =>
                                        this.handleChange(event, "addressLine1", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Address Line 2</label>
                                <input
                                    className={`inputFocus `}
                                    type="text"
                                    id="addressLine2"
                                    name="addressLine2"
                                    autoComplete='off'
                                    value={this.state.companyDetails.addressLine2}
                                    onChange={(event) =>
                                        this.handleChange(event, "addressLine2", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Address Line 3</label>
                                <input
                                    className={`inputFocus `}
                                    type="text"
                                    id="addressLine3"
                                    name="addressLine3"
                                    autoComplete='off'
                                    value={this.state.companyDetails.addressLine3}
                                    onChange={(event) =>
                                        this.handleChange(event, "addressLine3", "companyDetails")
                                    }
                                />
                            </div>

                        </div>
                        <div className="item-grp !flex !gap-2.5 mt-3">
                            <div className="input-grp  w-full">
                                <label>Pin code</label>
                                <input
                                    type="number"
                                    id="pinCode"
                                    name="pinCode"
                                    className={`inputFocus ${this.state.validState?.error?.pinCode ? "errorInput" : ""}`}
                                    autoComplete='off'
                                    value={this.state.companyDetails.pinCode}
                                    onChange={(event) =>
                                        this.handleChange(event, "pinCode")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>State</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.state ? "errorInput" : ""}`}
                                    type="text"
                                    id="state"
                                    name="state"
                                    autoComplete='off'
                                    value={this.state.companyDetails.state}
                                    onChange={(event) =>
                                        this.handleChange(event, "state")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Location</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.location ? "errorInput" : ""}`}
                                    type="text"
                                    id="location"
                                    name="location"
                                    autoComplete='off'
                                    value={this.state.companyDetails.location}
                                    onChange={(event) =>
                                        this.handleChange(event, "location")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Pan No.</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.panNo ? "errorInput" : ""}`}
                                    type="text"
                                    id="panNo"
                                    name="panNo"
                                    autoComplete='off'
                                    value={this.state.companyDetails.panNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "panNo")
                                    }
                                />
                            </div>
                        </div>
                        <div className="item-grp !flex !gap-2.5 mt-3">
                            <div className="input-grp w-full">
                                <label>Bank Name</label>
                                <input
                                    type="text"
                                    id="bankName"
                                    name="bankName"
                                    className={`inputFocus ${this.state.validState?.error?.bankName ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.bankName}
                                    onChange={(event) =>
                                        this.handleChange(event, "bankName", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp  w-full">
                                <label>Branch</label>
                                <input
                                    type="text"
                                    id="branch"
                                    name="branch"
                                    className={`inputFocus ${this.state.validState?.error?.branch ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.branch}
                                    onChange={(event) =>
                                        this.handleChange(event, "branch", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Account No.</label>
                                <input
                                    type="number"
                                    id="acNo"
                                    name="acNo"
                                    className={`inputFocus ${this.state.validState?.error?.acNo ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.acNo}
                                    onChange={(event) =>
                                        this.handleChange(event, "acNo", "companyDetails")
                                    }
                                />
                            </div>

                            <div className="input-grp  w-full">
                                <label>IFSC Code</label>
                                <input
                                    className={`inputFocus ${this.state.validState?.error?.ifscCode ? "errorInput" : ""}`}
                                    type="text"
                                    id="ifscCode"
                                    name="ifscCode"
                                    autocomplete="off"
                                    value={this.state.companyDetails.ifscCode}
                                    onChange={(event) =>
                                        this.handleChange(event, "ifscCode", "companyDetails")
                                    }
                                />
                            </div>
                        </div>
                        <div className="item-grp !flex !gap-2.5 mt-3">
                            <div className="input-grp w-full">
                                <label>Terms & Condition Line 1</label>
                                <input
                                    type="text"
                                    id="termsConditionLine1"
                                    name="termsConditionLine1"
                                    className={`inputFocus ${this.state.validState?.error?.termsConditionLine1 ? "errorInput" : ""}`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.termsConditionLine1}
                                    onChange={(event) =>
                                        this.handleChange(event, "termsConditionLine1", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Terms & Condition Line 2</label>
                                <input
                                    type="text"
                                    id="termsConditionLine2"
                                    name="termsConditionLine2"
                                    className={`inputFocus `}
                                    autocomplete="off"
                                    value={this.state.companyDetails.termsConditionLine2}
                                    onChange={(event) =>
                                        this.handleChange(event, "termsConditionLine2", "companyDetails")
                                    }
                                />
                            </div>

                        </div>
                        <div className="item-grp !flex !gap-2.5 mt-3">
                            <div className="input-grp w-full">
                                <label>Terms & Condition Line 3</label>
                                <input
                                    type="text"
                                    id="termsConditionLine3"
                                    name="termsConditionLine3"
                                    className={`inputFocus `}
                                    autocomplete="off"
                                    value={this.state.companyDetails.termsConditionLine3}
                                    onChange={(event) =>
                                        this.handleChange(event, "termsConditionLine3", "companyDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>Terms & Condition Line 4</label>
                                <input
                                    type="text"
                                    id="termsConditionLine4"
                                    name="termsConditionLine4"
                                    className={`inputFocus`}
                                    autocomplete="off"
                                    value={this.state.companyDetails.termsConditionLine4}
                                    onChange={(event) =>
                                        this.handleChange(event, "termsConditionLine4", "companyDetails")
                                    }
                                />
                            </div>

                        </div>
                        <div className=" mt-5">

                            <button
                                className="add-btn"
                                onClick={() => this.addEditUserProfile()}
                            >
                                {this.state.isEditing ? "Save" : "Add"}

                            </button>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserProfile;